(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonial-section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.custom-testimonials-container').slick({
      // normal options...
      slidesToShow: 3,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-video-carousel"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.custom-videos-container').slick({
      // normal options...
      slidesToShow: 5,
      dots: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    //interaction observer code
    const videos = document.querySelectorAll('.custom-video');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
            video.muted = true;
          }
        });
      },
      { threshold: 0.5 }
    );

    videos.forEach((video) => {
      observer.observe(video);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  const customBuyNowButton = document.getElementsByClassName("custom-buy-now-button");
  customBuyNowButton[0].addEventListener("click", ()=>{
    const morePaymentOptionsButton = document.getElementById('more-payment-options-link');
    morePaymentOptionsButton.click()
  })


  
  // window.onload = function() {
  //   const morePaymentOptionsButton = document.getElementById('more-payment-options-link');
  //   // morePaymentOptionsButton.style.display = 'flex';
  //   morePaymentOptionsButton.style.setProperty("display", "flex", "important");
  //   morePaymentOptionsButton.innerHTML = 'Buy Now';
  // };
  // window.addEventListener("domContentLoaded", () => {
  //     console.log("All resources loaded!");
  // }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"]) return;
  try {
    
  const linksCta = document.querySelectorAll('.links-cta');
  const linksContainer = document.querySelectorAll('.links-container');

  linksCta.forEach((element, index) => {
    element.addEventListener("click", ()=>{
      const clickIndex = index

      const computedStyles = window.getComputedStyle(linksContainer[clickIndex]);

      if ((computedStyles.display=="flex")) {
        linksContainer[clickIndex].style.display="none"
      }
      else{
        linksContainer[clickIndex].style.display="flex"
      }
    })
  });

  } catch(e) { console.error(e); }
})();
})();
